import { Channel as ServiceChannel } from 'services/chat';
import { Channel } from '../types';

/**
 * Helper function to convert API Channel to local Channel model
 * This centralizes the conversion logic to avoid duplication
 */
export const convertApiChannelToLocalModel = (
	apiChannel: ServiceChannel,
	userId?: string
): Channel => {
	// Check if the channel has all required data
	if (!apiChannel) {
		console.error('Received null or undefined apiChannel in convertApiChannelToLocalModel');
		return new Channel('error', 'Invalid Channel', '', [], 0, '', 0, 0);
	}

	try {
		const newChannel = new Channel(
			apiChannel.id,
			apiChannel.name || 'Unnamed Channel',
			apiChannel.image || '',
			apiChannel.users?.map((u) => u.id) || [],
			apiChannel.channel_type,
			apiChannel.lastMessage?.id || '',
			apiChannel.lastMessage?.createdAt || 0,
			apiChannel.notificationCount || 0
		).setServiceLastMessage(apiChannel.lastMessage);

		// Process direct message channels to set proper display name from the other user
		if (
			apiChannel.channel_type === 0 ||
			apiChannel.channel_type === 4 ||
			apiChannel.channel_type === 5
		) {
			// Make sure we have users array
			if (apiChannel.users && apiChannel.users.length > 0) {
				// If we have userId, filter out the current user to show the other person's name
				if (userId) {
					const otherUsers = apiChannel.users.filter((u) => u.id !== userId);
					if (otherUsers.length > 0) {
						newChannel.setDataFromUser(otherUsers[0]);
					} else {
						// Fallback to first user if filtering resulted in empty array
						newChannel.setDataFromUser(apiChannel.users[0]);
					}
				} else {
					// If userId isn't available yet, just use the first user's data
					newChannel.setDataFromUser(apiChannel.users[0]);
				}
			}
		}

		return newChannel;
	} catch (error) {
		console.error('Error in convertApiChannelToLocalModel:', error, apiChannel);
		return new Channel('error', 'Error Channel', '', [], 0, '', 0, 0);
	}
}; 